import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AdvancedTypography from 'Components/UI/AdvancedTypography';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {
  },
  dialog: {},
  dialogContent: {
    margin: theme.spacing(2, 0, 2, 0),
  },
  dialogActionsCentered: {
    justifyContent: 'center',
  },
});

export const AuthenticationFactorActionModifyText = (authenticationFactorResource) => {
  switch (authenticationFactorResource.attr('authenticationType')) {
    case 'password':
      return `Modify ${authenticationFactorResource.selectedOptionPrompt('authenticationType')}`;
    default:
      return `Disable ${authenticationFactorResource.selectedOptionPrompt('authenticationType')}`;
  }
};

const AuthenticationFactorListItemModifyAction = ({
  className,
  classes,
  authenticationFactorResource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleUpdateAuthenticationFactor = (authenticationType) => {
    logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Authentication Type Modify: Open change password modal', {
      eventProperties: {
        authenticationType,
      },
    });
    loadModalCollectionByLink(authenticationFactorResource.relationship(fr.relationships.authenticationFactorModify.name).link('related').url());
  };

  return (
    <AdvancedTypography
      className={classNames(classes.root, className)}
      fragments={
          [{
            color: 'secondary',
            onClick: () => handleUpdateAuthenticationFactor(authenticationFactorResource.attr('authenticationType')),
            text: AuthenticationFactorActionModifyText(authenticationFactorResource),
            underline: true,
            innerComponentProps: {
              test: `security-settings-${authenticationFactorResource.attr('authenticationType')}-modify-link`,
            },
          }]
        }
    />
  );
};

AuthenticationFactorListItemModifyAction.defaultProps = {
  className: '',
};

AuthenticationFactorListItemModifyAction.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthenticationFactorListItemModifyAction);
